export default "__VITE_ASSET__DJqr7wzT__"